import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";
import BookMockup from "./BookMockup";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;

const lines = [
  { text: "Transforme seu", italic: false },
  { text: "conhecimento em uma", italic: false },
  { text: "profissão real.", italic: true },
];

const Hero = () => (
  <section data-testid="hero-section" className="relative min-h-screen overflow-hidden">
    <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,0.08),transparent_50%)]" />
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 pb-24 pt-32 sm:pt-40 lg:grid-cols-[1.15fr_0.85fr] lg:px-12">
      <div>
        <motion.div
          className="mb-10 inline-flex items-center gap-3 rounded-full border border-[rgba(212,175,55,0.3)] bg-[rgba(212,175,55,0.06)] px-5 py-2"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#D4AF37] opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#D4AF37]" />
          </span>
          <span className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#F3E5AB] sm:text-xs">
            Guia prático · E-book completo
          </span>
        </motion.div>

        <h1 data-testid="hero-headline" className="font-serif-display text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className={`block ${line.italic ? "gold-shimmer italic" : ""}`}
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.45 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
              >
                {line.text}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          data-testid="hero-subheadline"
          className="mt-8 max-w-xl text-base leading-relaxed text-[#A1A1AA] sm:text-lg"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1 }}
        >
          Do zero ao primeiro cliente, sem complicação. Um método direto, passo a passo,
          para começar a trabalhar como Social Media — mesmo que você esteja dando os
          primeiros passos no mercado digital.
        </motion.p>

        <motion.div
          className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.3 }}
        >
          <a
            data-testid="hero-cta-button"
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 rounded-full bg-[#D4AF37] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-[#0A0A0A] transition-colors duration-300 hover:bg-[#F3E5AB]"
          >
            Garantir meu e-book agora
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
          </a>
          <a
            data-testid="hero-chapters-link"
            href="#capitulos"
            className="group inline-flex items-center justify-center gap-3 rounded-full border border-[rgba(255,255,255,0.15)] px-8 py-4 text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
          >
            <BookOpen className="h-4 w-4" />
            Ver os capítulos
          </a>
        </motion.div>

        <motion.div
          className="mt-14 flex flex-wrap items-center gap-x-8 gap-y-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.6 }}
        >
          {["8 capítulos", "Exercícios práticos", "Checklists prontos", "Acesso imediato"].map((item) => (
            <span key={item} className="font-mono-label flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#71717A] sm:text-xs">
              <span className="h-1 w-1 rotate-45 bg-[#D4AF37]" />
              {item}
            </span>
          ))}
        </motion.div>
      </div>

      <BookMockup />
    </div>
  </section>
);

export default Hero;
